//* Libraries imports
import z from "zod";

//* Schemas imports
import { nameSchema } from "../../name";
import { dateFormat } from "../../date";

export const paginatedProcess = z.object({
  id: z.number(),
  name: nameSchema,
  start: dateFormat,
  end: dateFormat,
  description: z.string(),
  online: z.boolean(),
  simulation: z.number(),
  createdAt: dateFormat,
});
export type PaginatedProcess = z.infer<typeof paginatedProcess>;

const subFeatureSchema = z.object({
  id: z.string(),
  featureId: z.string(),
  subFeatureKey: z.string(),
  label: z.string(),
  color: z.string(),
  icon: z.string(),
  permissionEnabled: z.boolean(),
});

const featureSchema = z.object({
  id: z.string(),
  module_id: z.string(),
  feature_key: z.string(),
  label: z.string(),
  color: z.string(),
  icon: z.string(),
  permissionEnabled: z.boolean(),
  subFeatures: z.array(subFeatureSchema),
});

const faculdadePermissionSchema = z.object({
  id: z.string(),
  moduleKey: z.string(),
  label: z.string(),
  description: z.string(),
  enabled: z.boolean(),
  features: z.array(featureSchema),
});

export const fullProcess = z
  .object({
    updatedAt: dateFormat,
    rules: z.string(),
    typeFiscalization: z.string(),
    isFinished: z.boolean(),
    mobile: z.boolean(),
    examPerTime: z.boolean(),
    interview: z.boolean(),
    fullScreen: z.boolean(),
    chatType: z.string(),
    saveTimer: z.number(),
    saveTimerPreExam: z.number(),
    mockExam: z.number(),
    blocked: z.boolean(),
    movement: z.boolean(),
    goodQuality: z.boolean(),
    examTime: z.number().nullable(),
    timeType: z.string(),
    screenExtendedRestrict: z.boolean(),
    screenSharing: z.boolean(),
    replaceVideoScreen: z.boolean(),
    showDraft: z.boolean(),
    restrictAccess: z.boolean(),
    timeInitRestrict: z.string().nullable(),
    timeEndRestrict: z.string().nullable(),
    college: z.object({
      id: z.number(),
      name: z.string(),
      slug: z.string(),
    }),
    faculdadePermissions: z.array(faculdadePermissionSchema).nullable(),
  })
  .merge(paginatedProcess);
export type FullProcess = z.infer<typeof fullProcess>;




